

exports.__esModule = true;
exports.$GenericErrorPageRoute = undefined;

require('./directive');

var _squid = require('squid');

var $GenericErrorPageRoute = exports.$GenericErrorPageRoute = _squid.$ComponentRoute.extend('$GenericErrorPageRoute', {

    path: 'genericErrorPage',
    directive: 'xo-generic-error-page-directive',
    titleContent: 'genericError.pleaseTryAgain',
    query: ['code'],
    // need to find these values
    trackingData: {
        fptiState: 'fatal_error',
        templateName: 'genericError.dust',
        pageGoal: 'Generic Error',
        pageQualifier: 'blockNonDomesticShipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-generic-error',
                'pagename2': '%::fullpage-generic-error:member:hermes:',
                'version': 'member:%:'
            }
        }
    },

    auth: false,

    children: []
});

angular.value("$GenericErrorPageRoute", $GenericErrorPageRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-error/xo-generic-error/route.js
// module id = ./pages/xo-error/xo-generic-error/route.js
// module chunks = 1